import React from 'react';
import { makeStyles } from 'tss-react/mui';

import * as Colors from 'src/theme/colors';

import { FormPageHeaderProps } from '../formPageTypes';

import FormPageHeaderBase from './FormPageHeaderBase';

const useStyles = makeStyles<BorderFormPageHeaderProps>()((_, props) => ({
  pageAction: {
    border: 'none',
    ...(props.borderPosition === 'top'
      ? { borderTop: `1px solid ${Colors.DividersAndCardBorders}` }
      : { borderBottom: `1px solid ${Colors.DividersAndCardBorders}` }),
    borderRadius: 0,
  },
}));

interface BorderFormPageHeaderProps {
  borderPosition: 'top' | 'bottom';
}
const BorderFormPageHeader: React.FC<
  BorderFormPageHeaderProps & FormPageHeaderProps
> = ({ borderPosition, ...rest }) => {
  const { classes } = useStyles({ borderPosition });

  return <FormPageHeaderBase {...rest} className={classes.pageAction} />;
};

export default BorderFormPageHeader;
